import BuildingAnalysis from '../modules/analyse/building'
import OrganizationAnalysis from '../modules/analyse/organization'
import MeterAnalysis from '../modules/analyse/meter'

import Organizations from '../modules/admin/organizations'
import Building from '../modules/admin/building'
import Organization from '../modules/admin/organization'
import Contracts from '../modules/admin/contracts'
import { gql, useQuery } from '@apollo/client'
import Loader from '../genericComponents/Loader'
import { useNavigate } from 'react-router'
import Onboarding from '../modules/onboarding'
import PaymentReturn from '../modules/PaymentReturn'
import { useEffect } from 'react'

const RerouteToFirstOrganization = () => {

  const GETORGANIZATION = `query {
    organizations{
      items{
        displayName
        uuid
      }
    }
  }
  `
  const navigate = useNavigate();
  const { data, loading } = useQuery(gql(GETORGANIZATION));
  
  useEffect(() => {
    if (!loading && data) {
      const organization = data.organizations.items[0];
      if (!organization) {
        navigate('/onboarding');
      } else {
        navigate('/analysis/organization/' + organization.displayName + '/' + organization.uuid);
      }
    }
  }, [loading, data, navigate]);

  return <Loader text={"Loading first organization"} />


}
const getRoutes = ({ callback, user, params }) => {
  //user and path are optionals to get things from api.

  const routes = [
    {
      path: '/',
      isExact: true,
      component: RerouteToFirstOrganization //Should be the definition, not the instantiated control so: ModuleA and NOT <ModuleA></ModuleA>
    },
    {
      path: '/onboarding',
      isExact: true,
      component: Onboarding
    },
    {
      path: '/paymentreturn',
      isExact: true,
      component: PaymentReturn
    },
    // {
    //   path: '/admin/contracts',
    //   isExact: true,
    //   component: Contracts
    // },    
    // {
    //   path: '/admin/organizationmanagement/',
    //   isExact: true,
    //   component: Organizations
    // },
    // {
    //   path: '/admin/organizationmanagement/organizations',
    //   isExact: true,
    //   component: Organizations
    // },
    // {
    //   path: '/admin/organizationmanagement/organization/:name/:id',
    //   component: Organization
    // },
    {
      path: '/admin/organizationmanagement/building/:name/:id',
      component: Building
    },
    {
      path: '/analysis/meter/:meterType/:name/:id',
      component: MeterAnalysis
    },
    // {
    //   path:'/analysis/organizations',
    //   isExact:true,
    //   component:OrganizationAnalysis
    // },   
    {
      path: '/analysis/organization/:name/:id',
      isExact: true,
      component: OrganizationAnalysis
    },
    {
      path: '/analysis/building/:name/:id',
      isExact: true,
      component: BuildingAnalysis
    },
  ]

  callback(routes)
}
export default getRoutes
